<template>
  <div>
    <!--我的考试-->
    <!--标题-->
    <p class="fav_mainHead">我的考试</p>
    <!--内容-->
    <h5 class="none_ts" v-if="examList.length == 0" style="text-align: center;">
      <img src="@/assets/images/none_data.jpg" alt="">
    </h5>
    <div class="exam_con" v-if="examList.length > 0" v-for="item in examList" :key="item.id">
      <div class="exam_con_left">
        <img v-if="item.faceUri" :src="item.faceUri" class="exam_con_img"/>
        <img v-if="!item.faceUri || item.faceUri==''" src="@/assets/images/test_img.jpg" class="exam_con_img"/>
        <div>
          <p class="font_eighteen  mb13">{{item.title}}</p>

          <p class=" color_e72b12 mb13" v-if="!item.userCntTest || item.userCntTest=='0'">合格标准：满分{{item.score}}分，{{item.passline}}分及格</p>
          <p class=" color_e72b12 mb13" v-if="item.userCntTest>'0' && parseFloat(item.userScore)>=parseFloat(item.passline)">考试成绩 ：合格</p>
          <p class=" color_e72b12 mb13" v-if="item.userCntTest>'0' && parseFloat(item.userScore)<parseFloat(item.passline)">考试成绩 ：不合格</p>

          <p>考试时长{{item.time}}分钟 考题数量：{{item.cntQuestion}}题</p>
          <p>开放时间：{{item.startDate}} 至 {{item.endDate}}</p>
        </div>
      </div>
      <div class="exam_con_right">
        <p class="font12  pr18">{{item.isUsed}}人次参与</p>
        <a href="javascript:;" class="exam_con_right_a1" @click="startExam(item.id, '0')">开始考试</a>
        <a href="javascript:;" class="exam_con_right_a2" v-if="item.examIdFinish && item.examIdFinish!=''" @click="examDetail(item.examIdFinish)">答题详情</a>
        <!--<a href="javascirpt:;" class="exam_con_right_a1" v-if="item.userCntTest>'0' && item.userScore<item.passline" @click="startExam(item.id)">重新考试</a>-->
      </div>
    </div>
    <div v-if="examList.length > 0" class="zy_list_bottom">
      <dl>
        <dd>
          <paginate :click-handler="clickCallback" :page-count=pages
                    :container-class=$global.paginationOptions.container_class :page-class=$global.paginationOptions.page_class :page-link-class=$global.paginationOptions.page_link_class
                    :prev-class=$global.paginationOptions.prev_class :prev-link-class=$global.paginationOptions.prev_link_class
                    :next-class=$global.paginationOptions.next_class :next-link-class=$global.paginationOptions.next_link_class
                    :first-last-button=$global.paginationOptions.first_last_button
                    :active-class=$global.paginationOptions.active_class
                    :disabled-class=$global.paginationOptions.disabled_class
                    :first-button-text=$global.paginationOptions.first_button_text
                    :last-button-text=$global.paginationOptions.last_button_text
                    :prev-text=$global.paginationOptions.prev_text
                    :next-text=$global.paginationOptions.next_text>
          </paginate>
        </dd>
      </dl>
    </div>
    <!--/我的考试-->
  </div>
</template>
<script>
  import { getCookie } from '@/store/cookies'
import Paginate from 'vuejs-paginate'
export default {
  components: { Paginate },
  data () {
    return {
      filter: {
        pageNo: 1,
        pageSize: 3,
        type: '1',
        isUsed: '1'
      },
      examList: [],
      pages: 0
    }
  },
  created () {
    this.getUserExams(this.filter)
  },
  methods: {
    clickCallback (pageNum) {
      this.filter.pageNo = pageNum
      this.getUserExams(this.filter)
    },
    getUserExams (filter) {
      this.$api.post(this.$global.examApiPath, '/examPaper/searchByUserOnly', filter, r => {
        if (r.data && r.data.length>0) {
          this.examList = r.data
          this.pages = Math.ceil(r.cntData / this.filter.pageSize)
        } else {
          this.examList = []
          this.pages = 0
        }
      })
    },
    startExam (paperId, type) {
      var path = this.$OR.getUrl(getCookie('org').businessId)
      this.$router.push({
        path: path + '/examReady/' + paperId + '/' + type
      })
    },
    examDetail (examId) {
      var path = this.$OR.getUrl(getCookie('org').businessId)
      this.$router.push({
        path: path + '/examResult/' + examId
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/page/modules/uc/examination.vue